"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.for-each");

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.assign");

var _objectInterface = require("./interface/objectInterface");

function defaults(object) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  return sources.filter(function (item) {
    return (0, _typeof2.default)(item) === 'object' && item !== null;
  }).reduce(function (prev, item) {
    (0, _keys.default)(item).forEach(function (key) {
      if (!Object.prototype.hasOwnProperty.call(prev, key) || prev[key] === void 0) {
        prev[key] = item[key];
      }
    });
    return prev;
  }, (0, _assign.default)({}, object));
}

defaults.default = defaults;
var _default = defaults;
exports.default = _default;
module.exports = exports["default"];